import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { authEvents, setAccessTokenProvider } from '@/shared/auth/tokenProvider';
import { loginRequest, msalInstance } from './auth/msalConfig';

/**
 * Registers where the HTTP layer gets its Bearer token. Called once from `main.tsx`.
 *
 * acquireTokenSilent returns the cached access token while it's valid (no network call). Near
 * expiry it renews it with the refresh token. If that's no longer possible (expired refresh token,
 * MFA, consent) we ask the user to sign in again via `interaction-required`.
 * Never call acquireTokenPopup here: it runs outside a user gesture and browsers block it.
 */
export const registerAccessTokenProvider = () => {
  setAccessTokenProvider(async ({ forceRefresh } = {}) => {
    const account = msalInstance.getActiveAccount();
    if (!account) return null;
    try {
      const result = await msalInstance.acquireTokenSilent({
        ...loginRequest,
        account,
        forceRefresh,
      });
      return result.accessToken;
    } catch (error) {
      if (error instanceof InteractionRequiredAuthError) authEvents.emit('interaction-required');
      return null;
    }
  });
};
